import React from 'react'
import Hero from '../components/Hero/Hero'



const Home = () => {
  return (
    <div >
       
    <Hero />
    

    
    </div>
  )
}

export default Home